import { isTransientRequestError } from './transientError';

function wait(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export async function retryRequest(run, { retries = 4, baseDelayMs = 400, maxDelayMs = 4000 } = {}) {
  let delay = baseDelayMs;
  let lastError;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      return await run();
    } catch (error) {
      lastError = error;
      if (attempt === retries || !isTransientRequestError(error)) {
        throw error;
      }
      await wait(delay);
      delay = Math.min(delay * 2, maxDelayMs);
    }
  }

  throw lastError;
}
